import React from 'react'
import StripePanel from '../components/Payment/StripePanel'
import PaymentHistory from '../components/Payment/PaymentHistory'
import FAQs from '../components/Payment/FAQs'

const Payment = () => (
  <div id="payment">
    <StripePanel />
    <PaymentHistory />
    <FAQs />
  </div>
)

export default Payment
